import Script from "next/script";
import { useIubendaPreferences } from "~/features/app/scripts/iubenda";
const WARM_CLIENT_ID = process.env.NEXT_PUBLIC_WARMLY_CLIENT_ID;
export function WarmlyScript() {
  const preferences = useIubendaPreferences();
  if (!WARM_CLIENT_ID || !preferences.measurement) {
    return null;
  }
  return <Script id="warmly-script-loader" strategy="lazyOnload" src={`https://opps-widget.getwarmly.com/warmly.js?clientId=${WARM_CLIENT_ID}`} />;
}